import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { UserAuthContextProvider } from "./context/AuthContext";
import { DarkModeContextProvider } from "./context/darkModeContext";
import { PendingListContextProvider } from "./context/PendingListContext";
import { UserChatsContextProvider } from "./context/ChatsContext";

ReactDOM.render(
  <React.StrictMode>
      <UserAuthContextProvider>
        <PendingListContextProvider>
          <UserChatsContextProvider>
          <App />
          </UserChatsContextProvider>
        </PendingListContextProvider>
      </UserAuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
